import { Component, Inject, OnInit, inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { EventTypes } from "src/app/core/constants/event-types";
import { AppSystemSettingForm } from "src/app/core/types/app-system-setting-form.type";
import { CreateSettingCommand } from "../../../../core/api/models/create-setting-command";
import { MainSettings } from "../../../../core/api/models/main-settings";
import { SettingDto } from "../../../../core/api/models/setting-dto";
import { UpdateSettingCommand } from "../../../../core/api/models/update-setting-command";
import { SettingsService } from "../../../../core/api/services/settings.service";
import { BaseFormPageComponent } from "../../../shared/base/components/base-form-page.component";
import { FormPageConfig } from "./../../../../core/models/form-page-config.model";
import { BaseFormModule } from "src/app/pages/shared/base/modules/base-form.module";
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: "app-setting-form",
    templateUrl: "./setting-form.component.html",
    styleUrls: ["./setting-form.component.scss"],
    imports: [BaseFormModule, ModalTitleComponent]
})
export class SettingFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<SettingDto> = {};

  model: CreateSettingCommand = {};
  showPrivateNumbers: boolean = false;
  showRoles: boolean = false;
  numberId: number;
  isShowNumberInput: boolean = false;
  numberValue: number;
  protected currentService = inject(SettingsService);
  //#endregion

  constructor(
    private dialogRef: MatDialogRef<SettingFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    this.formPageConfig.vocabs = data?.pageVocab;

    if (data.model) this.model = data.model;
  }

  ngOnInit() {
    try {
      this.initForm();
      this.changeFormValidations();
      this.initModel();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  //#region init methods

  initForm() {
    this.form = new FormGroup({
      key: new FormControl("", Validators.required),
      value: new FormControl("", [Validators.required]),
    });
  }

  initModel(): void {
    this.onChangeKey(this.model.key);
  }

  changeFormValidations() {
    try {
      if (this.formPageConfig.isEditMode) {
        this.form.controls["key"].disable();
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateSettingCommand) {
    this.unSubs();
    this.loading = true;
    model.value = model.value.toString();
    this.currentService
      .settingsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateSettingCommand) {
    this.unSubs();

    this.loading = true;
    this.currentService
      .settingsUpdatePut({ id: model.id.toString(), body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
  //#region final methods

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      this.model.value = this.model.value.toString();
      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  //#endregion
  onChangeKey(key: MainSettings) {
    try {
      this.model.key = key;
      if (key == MainSettings.DefaultNumber) {
        this.showRoles = false;
        this.showPrivateNumbers = true;
        this.isShowNumberInput = false;
        this.numberId = Number(this.model.value);
      } else if (key == MainSettings.LowestCreditOfUser) {
        this.showPrivateNumbers = false;
        this.isShowNumberInput = true;
      } else {
        this.showPrivateNumbers = false;
        this.showRoles = false;
        this.isShowNumberInput = false;
      }
      if (this.formPageConfig.isEditMode)
        this.numberValue = Number(this.model.value);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  changeValue(event, type: AppSystemSettingForm) {
    try {
      if (type == "privateNumber") this.model.value = event.id.toString();
      else if (type == "number") this.model.value = event;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
